import { render, staticRenderFns } from "./serviceSupport.vue?vue&type=template&id=1788eba8&"
import script from "./serviceSupport.vue?vue&type=script&lang=js&"
export * from "./serviceSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports